import React from 'react';
interface TelegramMsg {
  name: string;
  initials: string;
  color: string;
  msg: string;
  time: string;
  emoji?: string;
}
const ROW_1: TelegramMsg[] = [{
  name: 'Carlos M.',
  initials: 'CM',
  color: '#7B68EE',
  msg: 'Hermano acabo de cerrar mi primer contrato de $2,400 diseñando una plataforma para una empresa en España 🤯 Tardé 6 horas. Antes hubiera tardado semanas',
  time: '10:42 PM',
  emoji: '🔥'
}, {
  name: 'Valentina G.',
  initials: 'VG',
  color: '#E91E63',
  msg: 'Yo no sabía NADA de diseño y mi landing page ahora parece de Silicon Valley jajaja mi novio no lo podía creer',
  time: '3:15 PM',
  emoji: '😍'
}, {
  name: 'Javier S.',
  initials: 'JS',
  color: '#FF9800',
  msg: 'Gente, construí una app funcional en 2 días. DOS DÍAS. Me pagan $400/mes de mantenimiento por ella',
  time: '8:33 AM',
  emoji: '💰'
}, {
  name: 'María José L.',
  initials: 'MJ',
  color: '#4CAF50',
  msg: 'Cerré 3 contratos en 3 semanas con clientes en Miami y Barcelona. Desde Buenos Aires. El sistema funciona 🙌',
  time: '11:20 AM'
}, {
  name: 'Diego R.',
  initials: 'DR',
  color: '#00BCD4',
  msg: 'El banco de prompts es ORO PURO. Generé toda la estrategia de un cliente en una tarde. Antes me tomaba una semana',
  time: '5:47 PM',
  emoji: '⚡'
}, {
  name: 'Andrea P.',
  initials: 'AP',
  color: '#9C27B0',
  msg: 'Acabo de recibir mi primer pago de $1,500 por rediseñar una web 💵 En una tarde hice lo que una agencia cobra en semanas',
  time: '9:58 PM',
  emoji: '😭'
}];
const ROW_2: TelegramMsg[] = [{
  name: 'Luis F.',
  initials: 'LF',
  color: '#FF5722',
  msg: 'Bro yo era escéptico pero el sistema funciona. Ya tengo 2 clientes recurrentes pagándome $300/mes cada uno',
  time: '2:10 PM',
  emoji: '🚀'
}, {
  name: 'Elena R.',
  initials: 'ER',
  color: '#3F51B5',
  msg: 'Construí una herramienta de gestión para una clínica. Me pagan $400 al mes de mantenimiento. Tardé 2 días',
  time: '4:22 PM',
  emoji: '✨'
}, {
  name: 'Roberto C.',
  initials: 'RC',
  color: '#009688',
  msg: 'Tengo 52 años y pensé que la IA no era para mí. Mentira. Si sabes usar WhatsApp, sabes usar esto. Ya facturé $1,800',
  time: '7:15 AM'
}, {
  name: 'Camila V.',
  initials: 'CV',
  color: '#E91E63',
  msg: 'El módulo de monetización es BRUTAL. Cerré un contrato de $3,000 con un script que me tomó 5 minutos generar 😂',
  time: '1:33 PM',
  emoji: '📈'
}, {
  name: 'Sebastián M.',
  initials: 'SM',
  color: '#FFC107',
  msg: 'Pasé de cobrar $200 por proyecto a $2,000. Mismo esfuerzo. La diferencia es el arsenal de herramientas',
  time: '6:05 PM',
  emoji: '🤖'
}, {
  name: 'Paola H.',
  initials: 'PH',
  color: '#8BC34A',
  msg: 'Dejé mi trabajo de $400/mes. Este mes ya voy en $2,100 solo con proyectos de diseño + desarrollo IA 🎯',
  time: '12:40 PM',
  emoji: '🎯'
}];
function TelegramBubble({
  msg
}: {
  msg: TelegramMsg;
}) {
  return <div className="w-[280px] md:w-[320px] shrink-0 select-none" data-id="element-254">
      <div className="bg-[#1B2836] rounded-xl rounded-tl-sm border border-[#2B3D4F] p-3 md:p-3.5 shadow-[0_2px_8px_rgba(0,0,0,0.3)] relative" data-id="element-255">
        <div className="flex items-center gap-2.5 mb-2" data-id="element-256">
          <div className="w-8 h-8 rounded-full flex items-center justify-center text-[0.7rem] font-bold text-white shrink-0" style={{
          backgroundColor: msg.color
        }} data-id="element-257">
            {msg.initials}
          </div>
          <span className="text-[0.78rem] font-semibold" style={{
          color: msg.color
        }} data-id="element-258">
            {msg.name}
          </span>
        </div>
        <p className="text-[0.8rem] md:text-[0.85rem] text-[#D1D7DB] leading-[1.55] mb-1.5" data-id="element-259">
          {msg.msg}
        </p>
        <div className="flex items-center justify-end gap-1" data-id="element-260">
          {msg.emoji && <span className="text-[0.9rem] mr-auto" data-id="element-261">{msg.emoji}</span>}
          <span className="text-[0.6rem] text-[#8696A0]" data-id="element-262">{msg.time}</span>
          <svg width="16" height="11" viewBox="0 0 16 11" fill="none" className="text-[#53BDEB] shrink-0" data-id="element-263">
            <path d="M11.071 0.653a.457.457 0 0 0-.304-.153.457.457 0 0 0-.321.11L5.745 5.306 3.554 3.115a.452.452 0 0 0-.313-.135.452.452 0 0 0-.312.135l-.71.695a.434.434 0 0 0-.137.313c0 .12.046.227.137.318l2.924 2.924a.469.469 0 0 0 .312.135.469.469 0 0 0 .313-.135l5.604-5.604a.434.434 0 0 0 .136-.313.434.434 0 0 0-.136-.318l-.71-.695z" fill="currentColor" data-id="element-264" />
            <path d="M15.071 0.653a.457.457 0 0 0-.304-.153.457.457 0 0 0-.321.11L9.745 5.306 9.3 4.862l-.71.695 1.156 1.156a.469.469 0 0 0 .312.135.469.469 0 0 0 .313-.135l5.604-5.604a.434.434 0 0 0 .136-.313.434.434 0 0 0-.136-.318l-.71-.695z" fill="currentColor" data-id="element-265" />
          </svg>
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  return <section className="py-8 md:py-[120px] relative z-10 overflow-hidden" aria-label="Testimonios" data-id="element-266">
      <div className="max-w-[1100px] mx-auto px-4 md:px-12 mb-6 md:mb-16" data-id="element-267">
        <div className="text-center" data-id="element-268">
          <span className="section-tag" data-id="element-269">Arquitectos Reales</span>
          <h2 className="font-display text-[clamp(2.2rem,5vw,5rem)] tracking-[3px] leading-none" data-id="element-270">
            ELLOS YA
            <br data-id="element-271" />
            CONSTRUYEN
          </h2>
        </div>
      </div>
      <div className="marquee-track mb-2 md:mb-4" data-id="element-272">
        <div className="marquee-left flex gap-2.5 md:gap-4 w-max" data-id="element-273">
          {[...ROW_1, ...ROW_1].map((msg, idx) => <TelegramBubble key={`r1-${idx}`} msg={msg} data-id="element-274" />)}
        </div>
      </div>
      <div className="marquee-track" data-id="element-275">
        <div className="marquee-right flex gap-2.5 md:gap-4 w-max" data-id="element-276">
          {[...ROW_2, ...ROW_2].map((msg, idx) => <TelegramBubble key={`r2-${idx}`} msg={msg} data-id="element-277" />)}
        </div>
      </div>
    </section>;
}